import { useEffect, useState } from 'react';
import { useParams } from "react-router";
import { Spinner } from "../../components/Spinner/Spinner";
import { useFetchData } from "../../services/useFetchData.service";
import { Block } from "../../components/Block/Block";
import { Header } from "../../components/Header/Header";
import { Container } from "../../components/Container/Container";
import styles from './TextPages.module.css'
export const TextPages = ({theme='light',dataUrl='/Data/text-pages/' }) => {

  const { page } = useParams();
  const { data } = useFetchData(`${dataUrl+page}.json`);
  useEffect(() => {
    if(theme) {
      document.body.setAttribute('data-theme', theme);
    }else {
      document.body.removeAttribute('data-theme');
    }
  }, [theme]);
  if (!data) return <Spinner />;

  const { title, content, type } = data;
  const contentString = content.join('');
  return (
    <>
      <Header />
      <Block>
        <Container className={type === "accordion" ? '' : styles.container}>
          <h1 className={styles.title}>{title}</h1>
          {type === "accordion" ? <Accordion content={content} /> : <div className={styles.Content} dangerouslySetInnerHTML={{ __html: contentString }} />}

          <div className={styles.companyInfo}>DSO-THUB-G-D-FLEX-G109D, DTEC, Dubai Silicon Oasis, Dubai.</div>
        </Container>
      </Block>
    </>
  );
}
const Accordion = ({ content }) => {
  // Создаем массив состояний для каждого элемента аккордеона
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    // Если текущий элемент уже открыт, закрываем его, иначе открываем новый
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className={styles.accordion}>
      {content.map((item, index) => (
        <div className={styles.box} key={index}>
          <div className={styles.accordionHeader} onClick={() => toggleAccordion(index)}>
            <div className={styles.quest}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9 8.86494C9 7.11282 10.6479 5.72757 12.5443 6.04572C13.7507 6.24818 14.7404 7.1935 14.9523 8.34585C15.1659 9.51037 14.6432 10.576 13.7555 11.1894C12.7069 11.9125 12.0009 13.0009 12.0009 14.2355V14.5962M11.4941 18H12.5077" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path></svg>

            </div>
            <p>{item.question}</p>
            <span className={`${styles.arrow} ${openIndex === index ? styles.open : ''}`}>
              <svg data-v-b2e2cb13="" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M19.3686 16.5919C18.9401 17.0418 18.2454 17.0418 17.8169 16.5919L12.0596 10.5464L6.27601 16.6196C5.84751 17.0695 5.15281 17.0695 4.72431 16.6196C4.29581 16.1696 4.29581 15.4402 4.72431 14.9902L10.508 8.91695L10.5002 8.90875L12.0518 7.27945L19.3686 14.9625C19.7971 15.4125 19.7971 16.1419 19.3686 16.5919Z" fill="currentColor"></path></svg>
            </span>
          </div>
          <div className={`${styles.accordionContent} ${openIndex === index ? styles.open : ''}`}>{item.answer}</div>
        </div>
      ))}
    </div>
  );
};